import { Alert } from 'bootstrap';
window.BootstrapAlert = Alert;
